import { EInboundStatus, EInboundType } from '../enums/EInbound';
import { IColor } from '../interfaces/color';

const getInboundStatusName = (status: EInboundStatus): string => {
  switch (status) {
    case EInboundStatus.OPEN:
      return 'DRAFT';
    case EInboundStatus.PENDING:
      return 'PENDING';
    case EInboundStatus.PARTIAL:
      return 'PARTIAL';
    case EInboundStatus.COMPLETED:
      return 'COMPLETED';
    case EInboundStatus.VOID:
      return 'VOID';
    case EInboundStatus.ERROR:
      return 'ERROR';
    case EInboundStatus.SEND:
      return 'SEND';
    case EInboundStatus.SEND_ERROR:
      return 'SEND ERROR';
    default:
      return '';
  }
};

const getInboundStatusColor = (status: EInboundStatus): IColor => {
  let color: IColor = {
    bg: 'bg-blue-200',
    text: 'text-black',
  };
  switch (status) {
    case EInboundStatus.SEND:
    case EInboundStatus.OPEN:
      color = {
        bg: 'bg-yellow-100',
        text: 'text-yellow-700',
      };
      break;
    case EInboundStatus.COMPLETED:
      color = {
        bg: 'bg-green-100',
        text: 'text-green-700',
      };
      break;
    case EInboundStatus.PARTIAL:
      color = {
        bg: 'bg-green-100',
        text: 'text-green-700',
      };
      break;
    case EInboundStatus.VOID:
      color = {
        bg: 'bg-red-100',
        text: 'text-red-700',
      };
      break;
    case EInboundStatus.SEND_ERROR:
    case EInboundStatus.ERROR:
      color = {
        bg: 'bg-red-100',
        text: 'text-red-700',
      };
      break;
  }
  return color;
};

const getInboundStatusOptions = () =>
  Object.entries(EInboundStatus)
    .filter(([key]) => isNaN(Number(key)))
    .map(([, value]) => ({
      label: getInboundStatusName(value as EInboundStatus),
      value: value as EInboundStatus,
    }));

const getInboundTypeName = (status: EInboundType): string => {
  switch (status) {
    case EInboundType.NORMAL:
      return 'NORMAL';
    case EInboundType.RETURN:
      return 'RETURN';
    default:
      return '';
  }
};

const getInboundTypeColor = (status: EInboundType): IColor => {
  let color: IColor = {
    bg: 'bg-blue-200',
    text: 'text-black',
  };
  switch (status) {
    case EInboundType.NORMAL:
      color = {
        bg: 'bg-yellow-100',
        text: 'text-yellow-700',
      };
      break;
  }
  return color;
};

const getInboundTypeOptions = () =>
  Object.entries(EInboundType)
    .filter(([key]) => isNaN(Number(key)))
    .map(([, value]) => ({
      label: getInboundTypeName(value as EInboundType),
      value: value as EInboundType,
    }));

export {
  getInboundStatusName,
  getInboundStatusColor,
  getInboundStatusOptions,
  getInboundTypeName,
  getInboundTypeColor,
  getInboundTypeOptions,
};
